import React from 'react'
import './introduction.css'
import { introPara } from '../../utils/introductionData'

const Introduction = () => {
  return (
    <div className='p-4 mb-4'>
        <div className="container text-center">
            <div className="row">
                <div className="col-12 col-md-6 order-2 order-md-1 d-flex justify-content-center">
                    <div className='introWrapper'>
                        <div className='row g-0 align-items-center d-flex '>
                            <div className='col-auto waveWrapper'>
                                <img className='wavePhoto' src='wave.png' alt='...'/>
                            </div>
                            <h2 className='col text-start fw-semibold fs-1 ms-4'>
                                Hey there,
                            </h2>
                        </div>
                        <div>
                            <h1 className='fs-1 fw-bold custom-underline'>It's Aayush Srivastava.</h1>
                        </div>
                        <div className='m-2 text-start'>
                            <p className='m-5 fw-semibold text-secondary fs-5'>{introPara}</p>
                        </div>
                        <div>
                            <div className='d-flex justify-content-center gap-3'>
                                <a href='#contact'>
                                    <button className='btn greet-btn rounded-pill text-light fw-medium fs-5' style={{ width: '150px' }}>Say Hello &rarr;</button>
                                </a>
                                <a href='https://drive.google.com/file/d/1DlyaLXiPSNG0FIwqPXEUMGOKTNjlbCnh/view?usp=sharing' target="_blank" rel="noopener noreferrer">
                                    <button className='btn btn-outline-dark rounded-pill fw-medium fs-5' style={{ width: '150px' }}>My Resume</button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 order-1 order-md-2">
                    <img className='landingPagePhoto' src='aayush.png' alt='...'/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Introduction